(function () {
	angular
		.module('trackeye')
		.factory('InviteService', InviteService);

	InviteService.$inject = ["C4ApiService", "Invite", "Permissions", "$rootScope"];

	function InviteService(api, Invite, Permissions, $rootScope) {
		var collection = [],
			exports = {};

		exports.getCollection = function () {
			return collection;
		};

		exports.getById = function (uuid) {
			return collection.filter(function (invite) {
				return invite.getId() == uuid;
			});
		};

		exports.getInvitesByDevice = function (device) {
			if (!device)
				return [];

			return collection.filter(function (invite) {
				return invite.hasDevice(device.id);
			});
		};

		exports.delete = function (inviteId) {
			return api.forward('delete', '/invites/' + inviteId).then(function (resp) {
				for (var i = 0; i < collection.length; i++) {
					if (collection[i].getId() == inviteId) {
						collection.splice(i, 1);
						break;
					}
				}
				$rootScope.$broadcast('InviteService.update');
			}, angular.noop());
		};

		exports.create = function (email, device, permissions, expire) {
			return api.local('post', 'invites', {
				name: "te-unit-share",
				description: email,
				expire: expire,
				links: {
					users: [{email: email}],
					units: [{id: device.getUuid()}]
				}
			}).then(function (resp) {
				var invData = resp.data;

				invData.links = {
					users: [{email: email}],
					units: [device.getPlain()]
				};
				var invite = new Invite(invData);

				api.forward('post', '/invites/' + invite.getId() + '/units/' + device.getUuid() + '/permissions', permissions).then(function () {
					invite.setPermissions(permissions);
					collection.push(invite);
					$rootScope.$broadcast('InviteService.update');
				}, angular.noop());

			}, angular.noop());
		};

		exports.fetch = function () {
			collection = [];
			api.forward('get', '/invites/te-unit-share', {
				"include": "units,users",
				"fields[users]": "email",
				"fields[units]": "id,number,name"
			}).then(function (resp) {
				resp.data.forEach(function (data) {
					collection.push(
						(new Invite()).populate(data)
					);
				});
			}, angular.noop);
		};

		exports.add = function (invite) {
			collection.push(invite);
		};

		exports.factory = function (description) {
			return (new Invite('te-unit-share', description));
		};

		exports.update = function () {

		};

		exports.fetch();

		return exports;
	}
})();